import { type Lang, type MarketTerms, LANG_CODES, DEFAULT_WEB, applyTerms } from '@lms/i18n';
import { DICT } from './dict';

/**
 * 프론트 번역 — 말은 **요청마다 정해진다**(§16-3): 방문자가 설정에서 고른 값(쿠키) →
 * OS·브라우저 언어 → 기본 영어. 그 판단은 `site.ts` 의 `resolveLang()` 한 곳에서 하고,
 * 화면은 `site.lang` 만 본다(`market_conf.language` 는 한국형/글로벌형 스위치라 말이 아니다).
 * 서버 컴포넌트는 makeT(site.lang), 클라이언트는 SiteProvider + useT(i18n.tsx).
 *
 * 이 파일에는 'use client' 가 없다 — 지시어가 붙은 파일의 export 는 서버에서 함수로 부를 수
 * 없어서(실측 500), 서버·클라가 함께 쓰는 것은 여기 두고 훅·컨텍스트만 i18n.tsx 에 둔다.
 *
 * t() 는 사전 조회 → {n} 등 인자 치환 → **용어 토큰 치환(§16-18)** 순서다.
 * 도메인 단어는 사전에 하드코딩하지 않고 {teacher} 토큰으로 쓴다.
 */
export type T = (key: string, params?: Record<string, string | number>) => string;

export function toLang(v: string | null | undefined): Lang {
  return (LANG_CODES as string[]).includes(v ?? '') ? (v as Lang) : DEFAULT_WEB;
}

export function makeT(lang: Lang, terms: MarketTerms | null | undefined): T {
  return (key, params) => {
    let text = DICT[lang]?.[key] ?? DICT.ko?.[key] ?? key;
    if (params) for (const [k, v] of Object.entries(params)) text = text.replaceAll(`{${k}}`, String(v));
    return applyTerms(text, lang, terms);
  };
}

/** 다국어 JSON 필드(메뉴 이름 등) — 마켓 언어 우선, ko 폴백 */
export function pickName(name: Record<string, string> | null | undefined, lang: Lang): string {
  return name?.[lang] ?? name?.ko ?? Object.values(name ?? {})[0] ?? '';
}
